import { MULTI_OBJECT_INSTANCE_PREFIX } from "UI/UI.Controls/DataSource/MultiEdit/types";
import { CaseInsensitiveMap } from "../DataTypes/CaseInsensitiveMap";
import { GlobalContext } from "../GlobalContext";

export class ObjectUtils {
    /**
     * Pokusí se najít PropertyDescriptor naskrz chainem prototypů
     * @param o Objekt, pro který se hledá PropertyDescriptor
     * @param propertyKey Hledaná property
     */
    public static getPropertyDescriptorThroughChain(o: object, propertyKey: PropertyKey): PropertyDescriptor | undefined {
        let propertyDescriptor: PropertyDescriptor | undefined;
        let currentObject = o;

        do {
            propertyDescriptor = Object.getOwnPropertyDescriptor(currentObject, propertyKey); // Pokusí se získat propertyDescriptor na aktuálním objektu
            currentObject = Object.getPrototypeOf(currentObject); // Přesune se na prototyp aktuálního objektu
        } while (!propertyDescriptor && currentObject);

        return propertyDescriptor;
    }

    /**
     * TODO-rites
     * @param object
     * @param propertyKey
     */
    public static dynamicGetter(object: object, propertyKey: PropertyKey): boolean | null {
        const propertyDescriptor = ObjectUtils.getPropertyDescriptorThroughChain(object, propertyKey);
        if (!propertyDescriptor)
            return null;

        if (propertyDescriptor.value != null)
            return propertyDescriptor.value;
        else if (propertyDescriptor.get) {
            return propertyDescriptor.get.call(object);
        }

        return null;
    }

    /**
     * TODO-rites
     * @param object
     * @param propertyKey
     * @param valueToSet
     */
    public static dynamicSetter(object: object, propertyKey: PropertyKey, valueToSet: any): boolean {
        const propertyDescriptor = ObjectUtils.getPropertyDescriptorThroughChain(object, propertyKey);
        if (!propertyDescriptor)
            return false;

        if (propertyDescriptor.value != null)
            return false;
        else if (propertyDescriptor.set) {
            propertyDescriptor.set.call(object, valueToSet);
            return true;
        }

        return false;
    }

    /**
     * Převede klíče objektu na lowerCamelCase.
     * @param objectToTransform Objekt k převedení
     */
    public static transformKeysToLowerCamelCase(objectToTransform: object): object {
        const newObject: any = {};

        for (const [key, value] of Object.entries(objectToTransform)) {
            const newKeyName = key[0].toLowerCase() + key.substring(1);
            newObject[newKeyName] = value;
        }

        return newObject;
    }

    /**
     * Vrací seznam vlastností objektu ve formátu klíč-hodnota, který není case sensitive.
     * @param objectToTransform Objekt k převedení
     */
    public static getPropertiesCaseInsensitive<T>(objectToTransform: T): CaseInsensitiveMap<T> {
        return new CaseInsensitiveMap<any>(Object.entries(objectToTransform));
    }

    /**
     * Vrací informaci, jestli ID je neperzistentní (dočasné). Tj. začíná "iid".
     * @param id ID Objektu.
     */
    public static isIdTemporary(id: string): boolean {
        if (!id)
            return false;
        return id.toString().toLowerCase().startsWith("iid");
    }

    /**
     * Vrací informaci, jestli ID pochází z objektu pro multieditaci (MEOWObject).
     * @param id ID Objektu.
     */
    public static isIdMultiEdit(id: string): boolean {
        if (!id)
            return false;
        return id.toString().toLowerCase().startsWith(MULTI_OBJECT_INSTANCE_PREFIX);
    }

    /**
     * Odstraní přetypování z názvu atributu (např. A|B.x -> A.x)
     * @param attributeName Název atributu
     */
    public static removeTypeCasting(attributeName: string): string {
        const pos = attributeName.indexOf(".");

        if (pos > -1) {
            const withoutType = ObjectUtils._removeTypecastingWithoutAssociation(attributeName.substring(0, pos));
            return withoutType + attributeName.substring(pos);
        } else
            return ObjectUtils._removeTypecastingWithoutAssociation(attributeName);
    }

    private static _removeTypecastingWithoutAssociation(attributeName: string): string {
        const newAttrName = attributeName.replace(/\|([^.]+)\./g, ".");
        return newAttrName.split("|")[0];
    }
}

GlobalContext.registerType(ObjectUtils);
